export enum FeePaidByType {
  Broker = "Broker",
  Buyer = "Buyer",
  Correspondent = "Correspondent",
  Lender = "Lender",
  Seller = "Seller",
  ThirdParty = "ThirdParty",
}

const feePaidByOptions = [
  { label: "Broker", value: "Broker" },
  { label: "Buyer", value: "Buyer" },
  { label: "Correspondent", value: "Correspondent" },
  { label: "Lender", value: "Lender" },
  { label: "Seller", value: "Seller" },
  { label: "ThirdParty", value: "ThirdParty" },
];

export default feePaidByOptions;
